import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface ObjectTitle {
  tag: string;
  text: string;
}

interface Props {
  title?: string | ObjectTitle;
  tag?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiSectionTitle',
  props: {
    title: { default: '' },
    tag: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: string | ObjectTitle, tag: string };



const tagEl = computed(() => {
  if (
    (props.title as ObjectTitle)?.tag &&
    /^div|span|h[1-6]$/i.test((props.title as ObjectTitle).tag)
  )
    return (props.title as ObjectTitle).tag;

  return props.tag || 'h2';
});

const text = computed(() =>
  typeof props.title === 'string' ? props.title : props.title?.text,
);

return { __sfc: true,props, tagEl, text }
}

})